import React from 'react';

function MobileRadiusField({ radius, onRadiusChange }) {
  const mobileRadiusOptions = [
    { value: '', label: 'Any distance' },
    { value: '1', label: 'Within 1 mile' },
    { value: '3', label: 'Within 3 miles' },
    { value: '5', label: 'Within 5 miles' },
    { value: '10', label: 'Within 10 miles' },
    { value: '20', label: 'Within 20 miles' },
    { value: '9999', label: '30+ miles' },
  ];

  return (
    <div>
      <div className="px-4">
        <label
          className="block font-medium text-black text-sm mb-1"
          htmlFor="mobile-radius"
        >
          Search radius
        </label>

        <div className="relative">
          <select
            id="mobile-radius"
            className="px-3 min-h-[42px] text-[#6B7280] bg-grey-100 w-full border border-[#ebebeb] appearance-none rounded"
            value={radius}
            onChange={(e) => onRadiusChange(e.target.value)}
          >
            {mobileRadiusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>

          <svg
            width="10"
            height="7"
            aria-hidden="true"
            focusable="false"
            className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-[#6B7280]"
          >
            <use href="#icon-chevron-down" />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default MobileRadiusField;
